import Vue from "vue";
import VueI18n from "vue-i18n";
import zhPack from "./pages/Language/zh.json";
import enPack from "./pages/Language/en.json";

function getInitialLocale() {
  try {
    const v =
      localStorage.getItem("meeting_local_language")
    if (v === "en" || v === "zh") return v;
  } catch (e) {
    /* ignore */
  }
  return "zh";
}

Vue.use(VueI18n);

export default new VueI18n({
  locale: getInitialLocale(),
  fallbackLocale: "zh",
  silentFallbackWarn: true,
  messages: {
    zh: zhPack.lang,
    en: enPack.lang
  }
});



// WEBPACK FOOTER //
// ./src/i18n.js